import { render, staticRenderFns } from "./FileControl.vue?vue&type=template&id=a8a74dd6&lang=pug"
import script from "./FileControl.vue?vue&type=script&lang=js"
export * from "./FileControl.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports